<template>
  <div class="segment" :class="`${segmentType}-segment`">
    <h1 class="title">{{ segment.title }}</h1>

    <scroll-container :horizontalPadding="56">
      <playlist-group-card
        v-for="playlistGroup in playlistGroups"
        v-bind:key="playlistGroup.id"
        :backgroundImage="playlistGroupImage(playlistGroup)"
        :playlistGroup="playlistGroup"
        :segmentType="segmentType"
        :isDemo="isDemo"
        @demoActivated="$emit('demoActivated', playlistGroup.id)"
      />
      <template v-slot:scroll-button-left>
        <scroll-button-icon v-if="isSmileSegment" left color="blue" />
      </template>
      <template v-slot:scroll-button-right>
        <scroll-button-icon v-if="isSmileSegment" color="blue" />
      </template>
    </scroll-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'segment',
  props: {
    id: {
      type: String,
      required: true
    },
    isDemo: Boolean
  },
  data() {
    return {
      currentPage: 0
    }
  },
  computed: {
    ...mapState({ windowSize: state => state.window.size }),
    segment() {
      return this.$store.getters['contentTree/findSegment'](this.id)
    },
    playlistGroups() {
      return this.$store.getters['contentTree/findPlaylistGroupsFromSegment'](this.id)
    },
    segmentType() {
      return this.segment.segmentType.split('_')[0]
    },
    isSmileSegment() {
      return this.segmentType === 'smile'
    }
  },
  methods: {
    playlistGroupImage(playlistGroup) {
      let image

      if (this.segmentType === 'featured') {
        image = playlistGroup.banner
      } else {
        image = playlistGroup.thumbnail
      }

      return image
    }
  }
}
</script>

<style lang="scss" scoped>
.segment {
  width: 100%;
  padding-bottom: 40px;

  & > .title {
    font-size: 2rem;
    margin: 0 0 20px 56px;
    color: #453D4D;
  }

  &.smile-segment {
    padding-top: 20px;

    & > .title {
      margin-bottom: -12px;
    }

    .scroll-container {
      padding-top: 32px;
      padding-bottom: 32px;
    }
  }

  @media (hover: none),
         (max-width: 425px) and (orientation: portrait),
         (max-width: 812px) and (orientation: landscape) {
    padding-bottom: 16px;

    & > .title {
      margin: 0 0 0 16px;
      font-size: 16px;
    }

    &.smile-segment {
      padding-top: 12px;

      & > .title {
        margin: 0 0 -24px 16px;
      }
    }
  }
}
</style>

<style lang="scss">
.scroller-button {
  filter: drop-shadow(4px 4px 23px rgba(153, 51, 255, 0.5));
}

.smile-segment .scroller-button {
  filter: drop-shadow(4px 4px 23px #4CBFFF);
}
</style>
